import React from 'react';

import {Typography, type TypographyProps} from '@mui/material';
import type {ICustomFormItem} from '../../types';
import {getCustomFormItemTranslatedLabel} from '../../utils';

export interface CustomFormItemSectionProps extends TypographyProps {
	item: ICustomFormItem;
}

export const CustomFormItemSectionPrimitive = ({
	item,
	...props
}: CustomFormItemSectionProps) => {
	const {label} = item;
	return (
		<Typography variant="h6" {...props}>
			<span
				dangerouslySetInnerHTML={{
					__html: getCustomFormItemTranslatedLabel(label),
				}}
			/>
		</Typography>
	);
};

export const CustomFormItemSection = CustomFormItemSectionPrimitive;

export default CustomFormItemSection;
